import React from 'react';
import classNames from 'classnames';

const Alert = React.forwardRef(({ color = 'info', className, children, ...props }, ref) => (
  <div ref={ref} className={classNames('alert', `alert-${color}`, className)} role="alert" {...props}>
    {children}
  </div>
));

export default Alert;
